const TONE = {
  warn: 'bg-warn-tint text-warn-ink',
  bad: 'bg-bad-tint text-bad-ink',
  good: 'bg-good-tint text-good-ink',
  brand: 'bg-brand-50 text-brand-700',
}

const ICON_PATH = {
  offline: 'M2 4l20 16M5 12.5a11 11 0 0 1 4-2.3M8.5 16a6 6 0 0 1 3-1.4M12 20h.01',
  warning: 'M12 8v5M12 16.5h.01M10.3 3.9L2.7 17a2 2 0 0 0 1.7 3h15.2a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z',
  check: 'M20 6L9 17l-5-5',
}

/**
 * The inline status banner of design page 16: a full-width tinted row,
 * 14px radius, an icon and one line. It informs and never blocks — there is
 * no button to press before the learner can go on, only an optional action
 * beside the text (a «تلاش دوباره», a «باشه»).
 */
export default function StatusBanner({ tone = 'warn', icon = 'warning', action, className = '', children }) {
  return (
    <div role="status" className={`flex items-center gap-[11px] rounded-[14px] px-3.5 py-[13px] ${TONE[tone] ?? TONE.warn} ${className}`}>
      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" className="shrink-0" aria-hidden="true">
        <path d={ICON_PATH[icon] ?? ICON_PATH.warning} />
      </svg>
      <span className="flex-1 text-xs leading-[1.8]">{children}</span>
      {action}
    </div>
  )
}
